
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {AccountSocialTradingMasterCreateResponse} from './AccountSocialTradingMasterCreateResponse';
import {AccountCreateParams} from './AccountCreateParams';
import {FieldModelAccountCreateParams} from './AccountCreateParams';
import {SocialTradingAllocationMethod} from '../core/SocialTradingAllocationMethod';
import {FieldModelSocialTradingAllocationMethod} from '../core/SocialTradingAllocationMethod';
import {SocialTradingAccountMode} from '../core/SocialTradingAccountMode';
import {FieldModelSocialTradingAccountMode} from '../core/SocialTradingAccountMode';

/**
 * AccountSocialTradingMasterCreateRequest struct
 */
class AccountSocialTradingMasterCreateRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!AccountCreateParams=} masterAccount
   * @param {!SocialTradingAllocationMethod=} allocationMethod
   * @param {!SocialTradingAccountMode=} accountMode
   * @param {!number=} feePercent
   * @param {number=} commissionLogin
   * @param {AccountCreateParams=} commissionAccount
   * @constructor
   */
  constructor (parent = new Request(), masterAccount = new AccountCreateParams(), allocationMethod = new SocialTradingAllocationMethod(), accountMode = new SocialTradingAccountMode(), feePercent = 0.0, commissionLogin = null, commissionAccount = null) {
    super()
    super.copy(parent)
    this.MasterAccount = masterAccount
    this.AllocationMethod = allocationMethod
    this.AccountMode = accountMode
    this.FeePercent = feePercent
    this.CommissionLogin = commissionLogin
    this.CommissionAccount = commissionAccount
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountSocialTradingMasterCreateRequest}
   * @param {!AccountSocialTradingMasterCreateRequest} other Other struct
   * @returns {!AccountSocialTradingMasterCreateRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.MasterAccount != null) {
      this.MasterAccount = AccountCreateParams.fromObject(other.MasterAccount)
    } else {
      this.MasterAccount = null
    }
    if (other.AllocationMethod != null) {
      this.AllocationMethod = SocialTradingAllocationMethod.fromObject(other.AllocationMethod)
    } else {
      this.AllocationMethod = null
    }
    if (other.AccountMode != null) {
      this.AccountMode = SocialTradingAccountMode.fromObject(other.AccountMode)
    } else {
      this.AccountMode = null
    }
    if (other.FeePercent != null) {
      this.FeePercent = other.FeePercent
    } else {
      this.FeePercent = null
    }
    if (other.CommissionLogin != null) {
      this.CommissionLogin = UInt64.fromNumber(other.CommissionLogin)
    } else {
      this.CommissionLogin = null
    }
    if (other.CommissionAccount != null) {
      this.CommissionAccount = AccountCreateParams.fromObject(other.CommissionAccount)
    } else {
      this.CommissionAccount = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountSocialTradingMasterCreateRequest}
   * @returns {!AccountSocialTradingMasterCreateRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountSocialTradingMasterCreateRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountSocialTradingMasterCreateRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountSocialTradingMasterCreateRequest}
   * @param {!AccountSocialTradingMasterCreateRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountSocialTradingMasterCreateRequest)) {
      throw new TypeError('Instance of AccountSocialTradingMasterCreateRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountSocialTradingMasterCreateRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      MasterAccount: ((this.MasterAccount != null) ? this.MasterAccount : null),
      AllocationMethod: ((this.AllocationMethod != null) ? this.AllocationMethod : null),
      AccountMode: ((this.AccountMode != null) ? this.AccountMode : null),
      FeePercent: ((this.FeePercent != null) ? this.FeePercent : null),
      CommissionLogin: ((this.CommissionLogin != null) ? this.CommissionLogin.toNumber() : null),
      CommissionAccount: ((this.CommissionAccount != null) ? this.CommissionAccount : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountSocialTradingMasterCreateRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountSocialTradingMasterCreateRequest} other Object value
   * @returns {!AccountSocialTradingMasterCreateRequest} Created struct
   */
  static fromObject (other) {
    return new AccountSocialTradingMasterCreateRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountSocialTradingMasterCreateRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountSocialTradingMasterCreateRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountSocialTradingMasterCreateRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6478
  }
}

export { AccountSocialTradingMasterCreateRequest };

/**
 * Fast Binary Encoding AccountSocialTradingMasterCreateRequest field model
 */
class FieldModelAccountSocialTradingMasterCreateRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.MasterAccount = new FieldModelAccountCreateParams(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.AllocationMethod = new FieldModelSocialTradingAllocationMethod(buffer, this.MasterAccount.fbeOffset + this.MasterAccount.fbeSize)
    this.AccountMode = new FieldModelSocialTradingAccountMode(buffer, this.AllocationMethod.fbeOffset + this.AllocationMethod.fbeSize)
    this.FeePercent = new fbe.FieldModelDouble(buffer, this.AccountMode.fbeOffset + this.AccountMode.fbeSize)
    this.CommissionLogin = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.FeePercent.fbeOffset + this.FeePercent.fbeSize), buffer, this.FeePercent.fbeOffset + this.FeePercent.fbeSize)
    this.CommissionAccount = new fbe.FieldModelOptional(new FieldModelAccountCreateParams(buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize), buffer, this.CommissionLogin.fbeOffset + this.CommissionLogin.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.MasterAccount.fbeSize + this.AllocationMethod.fbeSize + this.AccountMode.fbeSize + this.FeePercent.fbeSize + this.CommissionLogin.fbeSize + this.CommissionAccount.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.MasterAccount.fbeExtra + this.AllocationMethod.fbeExtra + this.AccountMode.fbeExtra + this.FeePercent.fbeExtra + this.CommissionLogin.fbeExtra + this.CommissionAccount.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountSocialTradingMasterCreateRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6478
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.MasterAccount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MasterAccount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterAccount.fbeSize

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AllocationMethod.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountMode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.FeePercent.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.CommissionAccount.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionAccount.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionAccount.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {!AccountSocialTradingMasterCreateRequest} fbeValue Default value, defaults is new AccountSocialTradingMasterCreateRequest()
   * @returns {!AccountSocialTradingMasterCreateRequest} AccountSocialTradingMasterCreateRequest value
   */
  get (fbeValue = new AccountSocialTradingMasterCreateRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {!AccountSocialTradingMasterCreateRequest} fbeValue AccountSocialTradingMasterCreateRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.MasterAccount.fbeSize) <= fbeStructSize) {
      fbeValue.MasterAccount = this.MasterAccount.get()
    } else {
      fbeValue.MasterAccount = new AccountCreateParams()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MasterAccount.fbeSize

    if ((fbeCurrentSize + this.AllocationMethod.fbeSize) <= fbeStructSize) {
      fbeValue.AllocationMethod = this.AllocationMethod.get()
    } else {
      fbeValue.AllocationMethod = new SocialTradingAllocationMethod()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AllocationMethod.fbeSize

    if ((fbeCurrentSize + this.AccountMode.fbeSize) <= fbeStructSize) {
      fbeValue.AccountMode = this.AccountMode.get()
    } else {
      fbeValue.AccountMode = new SocialTradingAccountMode()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountMode.fbeSize

    if ((fbeCurrentSize + this.FeePercent.fbeSize) <= fbeStructSize) {
      fbeValue.FeePercent = this.FeePercent.get()
    } else {
      fbeValue.FeePercent = 0.0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.FeePercent.fbeSize

    if ((fbeCurrentSize + this.CommissionLogin.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionLogin = this.CommissionLogin.get()
    } else {
      fbeValue.CommissionLogin = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionLogin.fbeSize

    if ((fbeCurrentSize + this.CommissionAccount.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionAccount = this.CommissionAccount.get()
    } else {
      fbeValue.CommissionAccount = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionAccount.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {!AccountSocialTradingMasterCreateRequest} fbeValue AccountSocialTradingMasterCreateRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountSocialTradingMasterCreateRequest}
   * @param {AccountSocialTradingMasterCreateRequest} fbeValue AccountSocialTradingMasterCreateRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.MasterAccount.set(fbeValue.MasterAccount)
    this.AllocationMethod.set(fbeValue.AllocationMethod)
    this.AccountMode.set(fbeValue.AccountMode)
    this.FeePercent.set(fbeValue.FeePercent)
    this.CommissionLogin.set(fbeValue.CommissionLogin)
    this.CommissionAccount.set(fbeValue.CommissionAccount)
  }
}

export { FieldModelAccountSocialTradingMasterCreateRequest };

/**
 * Fast Binary Encoding AccountSocialTradingMasterCreateRequest model
 */
class AccountSocialTradingMasterCreateRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountSocialTradingMasterCreateRequest(this.buffer, 4)
  }

  /**
   * Get the AccountSocialTradingMasterCreateRequest model
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @returns {!FieldModelAccountSocialTradingMasterCreateRequest} model AccountSocialTradingMasterCreateRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountSocialTradingMasterCreateRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountSocialTradingMasterCreateRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @param {!AccountSocialTradingMasterCreateRequest} value AccountSocialTradingMasterCreateRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @param {!AccountSocialTradingMasterCreateRequest} value AccountSocialTradingMasterCreateRequest value, defaults is new AccountSocialTradingMasterCreateRequest()
   * @return {!object} Deserialized AccountSocialTradingMasterCreateRequest value and its size
   */
  deserialize (value = new AccountSocialTradingMasterCreateRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountSocialTradingMasterCreateRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountSocialTradingMasterCreateRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountSocialTradingMasterCreateRequestModel}
   * @param {!number} prev Previous AccountSocialTradingMasterCreateRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountSocialTradingMasterCreateRequestModel };
AccountSocialTradingMasterCreateRequest.__has_response = true;
AccountSocialTradingMasterCreateRequest.__response_class = AccountSocialTradingMasterCreateResponse;
